import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import makeStyles from '@mui/styles/makeStyles';
import Button from '@ts-core/components/Button';

const useStyles = makeStyles((theme) => ({
  option: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

const ExerciseTypeSelector = (props) => {
  const classes = useStyles();
  const { options, onSelectExerciseType } = props;

  const handleSelectExerciseType = useCallback(
    (type) => () => {
      onSelectExerciseType(type.id);
    },
    [onSelectExerciseType]
  );

  return (
    <Box width="100%" display="flex" flexDirection="column" py={2} justifyContent="center" alignItems="center">
      {options.map((option, index) => (
        <Button variant="contained" color="secondary" key={index} className={classes.option} onClick={handleSelectExerciseType(option)}>
          {option.label}
        </Button>
      ))}
    </Box>
  );
};

ExerciseTypeSelector.propTypes = {
  onSelectExerciseType: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ),
};

ExerciseTypeSelector.defaultProps = {
  options: [],
  onSelectExerciseType() {},
};

export default ExerciseTypeSelector;
